import { useTranslation } from "react-i18next";
import SimpleGrid from "@vfuk/core-simple-grid";
import { Stack, TableHeaderRow, TableRow } from "@ucchub/ui";
import Paragraph from "@vfuk/core-paragraph";
import { BillingProfileTableProps } from "./AllProps.types";
import { findObject } from "./FindName";

const BillingProfileTable = ({
  billingProfileId,
  billingProfileList,
  removeBillingProfileHeader,
}: BillingProfileTableProps) => {
  const { t } = useTranslation();
  const billingProfile = findObject(billingProfileList, billingProfileId);
  return (
    <>
      {!removeBillingProfileHeader && (
        <SimpleGrid spacing={4} columns={{ sm: 3 }}>
          <Stack direction="column" align="flex-start">
            <Paragraph weight={3} noMargin>
              {t("core:commercialCriteria:billing_profile")}
            </Paragraph>
            <Paragraph>{billingProfile?.name}</Paragraph>
          </Stack>
        </SimpleGrid>
      )}
      <SimpleGrid columns={{ sm: 2 }}>
        <>
          <TableHeaderRow
            headers={[
              t("core:commercialCriteria.profile_name"),
              t("core:commercialCriteria.profile_abbreviation"),
              t("core:commercialCriteria.default"),
            ]}
          />
          <TableRow
            rowData={[
              billingProfile?.name,
              billingProfile?.id?.abbreviation,
              billingProfile?.status === "active"
                ? t("core:commercialCriteria.active")
                : t("core:commercialCriteria.inactive"),
            ]}
          />
        </>
      </SimpleGrid>
    </>
  );
};
export default BillingProfileTable;
